import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Typography from '@hellodarwin/core/lib/components/common/typography';
import CTAsList from '../../common/CTAsList';
import { FaqHeaderContainer } from './styles';
const FaqHeader = ({ body, cta, title }) => {
    if (!(body === null || body === void 0 ? void 0 : body.length) && !(title === null || title === void 0 ? void 0 : title.length) && !cta)
        return null;
    return (_jsxs(FaqHeaderContainer, { children: [!!(title === null || title === void 0 ? void 0 : title.length) && (_jsx(Typography.Title, { level: 2, elementTheme: "h4", children: title })), !!(body === null || body === void 0 ? void 0 : body.length) && _jsx(Typography, { elementTheme: "body1", children: body }), !!cta && _jsx(CTAsList, { CTAs: [cta.fields] })] }));
};
export default FaqHeader;
